<template>
	<div class="">
		<div id="so-search-bar" class="header-top bg-white d-flex justify-content-between align-items-center p-x-20 p-y-12 responsive-item">
			<input type="text" class="w-100 f-16"
			       id="soseacrhbar-input"
			       style="border: none; outline: none"
			       :placeholder="placeholder"
			       autofocus
			       v-model="search"
			       @keyup="typing"
			>
			<img src="../../../assets/icons/closeblue.svg"
			     @click="close"/>
		</div>

		<div class="content-wrapper main-page m-t-12 p-x-20 bg-white p-d-12">
			<div class="f-regular f-16 f-c-midgrey"
			     v-if="search.length === 0">
				<div class="f-bold f-c-black">Anda bisa mencari:</div>
				<div v-html="searchInformation"></div>
			</div>
			<div class="f-regular f-16 f-c-midgrey"
			     v-if="waiting">
				Sedang mencari...
			</div>
			<div class="f-regular f-16 f-c-midgrey"
			     v-if="search.length > 0 && search.length < 2 && !waiting">
				Minimal 2 Karakter
			</div>
			<div class="f-regular f-16 f-c-midgrey"
			     v-if="search.length >= 2 && dataCount === 0 && !waiting">
				0 Hasil
			</div>
			<div class="f-regular f-16 f-c-midgrey"
			     v-if="search.length >= 2 && dataCount > 0 && !waiting">
				<img src="../../../../src/assets/icons/arrow-down.svg" alt="" class="m-r-8"> Hasil pencarian
			</div>
		</div>
	</div>
</template>

<script>
import { regex } from "@/store/utils/vars";

export default {
	name: "SOSearchBar",
	props: {
		dataCount: Number,
		context: String,
		value: String,
		waiting: Boolean,
    placeholder: {
      type: String,
      default: "Ketik minimal 2 karakter"
    },
		searchInformation: String,
	},
	data() {
		return {
			search: "",
			timer: null,
		}
	},
	mounted() {
		this.search = this.value
		$("#soseacrhbar-input").focus()
    if (document.getElementById("nav-bottom").classList.length > 0) {
      document.getElementById("so-search-bar").classList.add("set-responsive");
    }
	},
	watch: {
		search: {
			handler: function () {
				this.search = this.search.replace(regex.alphanumeric, "");
				this.search = this.search.replace(regex.emoji, "");
				this.$emit("return-search-value", this.search)
			}
		},
		value : {
			handler: function () {
				if (this.search !== this.value) this.search = this.value
			}
		},
	},
	methods: {
		typing() {
			// check search length first
			if (this.search.length < 2) {
				this.$emit("loading", false)
				return
			}

			this.$emit("loading", true)
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {
				if (this.search === "") {
					return
				}
				this.$emit("do-search", this.search)
			}, 2000);
		},
		close(payload) {
			this.$emit("close", payload)
		}
	}
}
</script>
<style scoped>
@media (min-width: 768px) {
  .set-responsive {
    padding-left: 368px;
  }
}
</style>